import { Fill, Stroke, Style } from 'ol/style';
import ApiaryDynamicType from '../../../../js/enums/ApiaryDynamicType';
import * as Color from 'color';
import { baseStyle } from '@vendor/libs/maps/styles/base';
export const apiaryBufferStyle = (type, muted = false) => {
    let colors = { stroke: '#FABD4B', fill: 'rgba(141,100,22,0.1)' };
    switch (type) {
        case ApiaryDynamicType.MINE.value:
            colors = { stroke: '#FF9700', fill: 'rgba(255,151,0,0.1)' };
            break;
        case ApiaryDynamicType.ASSOCIATION.value:
            colors = { stroke: '#2D6BB5', fill: 'rgba(45,107,181,0.1)' };
            break;
        case ApiaryDynamicType.ENTITY.value:
            colors = { stroke: '#171717', fill: 'rgba(150,150,150,0.2)' };
            break;
        case ApiaryDynamicType.OTHER.value:
            colors = { stroke: '#55B72C', fill: 'rgba(85,183,44,0.25)' };
            break;
    }
    if (muted) {
        colors.fill = Color(colors.fill)
            .alpha(Color(colors.fill).alpha() * 0.4)
            .hexa();
        colors.stroke = Color(colors.stroke)
            .alpha(Color(colors.stroke).alpha() * 0.3)
            .hexa();
    }
    return [
        new Style({
            stroke: new Stroke({
                color: colors.stroke,
                width: 2.5,
            }),
            fill: new Fill({
                color: colors.fill,
            }),
        }),
        new Style({
            stroke: new Stroke({
                color: 'white',
                width: 0.3,
            }),
        }),
    ];
};
export default (feature, resolution) => {
    return baseStyle(feature, resolution, () => {
        if (resolution > 250) {
            return new Style({});
        }
        return apiaryBufferStyle(feature.get('type'), feature.get('muted'));
    });
};
